import React from 'react'
import { useInfiniteQuery } from 'react-query'

import {
  SaleBookDetailAcceptProps,
  SaleBookDetailProps,
} from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/interface'
import { useWriterAction } from '@hooks/writer/useWriterAction'
import { useAuthentication } from '@hooks/useAuthentication'
import { WriterSalesType } from '@models/writer/WriterSalesType'

const PER_PAGE = 10

const withSaleBookDetail = (Component: React.FC<SaleBookDetailProps>) => {
  function WithSaleBookDetail({
    type,
    dateSelected,
  }: SaleBookDetailAcceptProps) {
    const writerClient = useWriterAction()
    const { isWriter, user } = useAuthentication()

    const { fetchNextPage, data, isFetchingNextPage, isLoading, hasNextPage } =
      useInfiniteQuery(
        ['sale-book', dateSelected, type],
        async ({ pageParam = 1 }) => {
          const res = await writerClient.getWriterSalesByProductType({
            page: pageParam,
            limitPerPage: PER_PAGE,
            startDate: dateSelected.startDate,
            endDate: dateSelected.endDate,
            productType: type,
            userId: user.id,
          })

          return res
        },
        {
          getNextPageParam: (lastPage: WriterSalesType) => {
            if (
              lastPage.salesDetail.page * PER_PAGE <
              lastPage.salesDetail.total
            )
              return lastPage.salesDetail.page + 1

            return undefined
          },
          enabled: isWriter,
        }
      )

    function handleFetchNextPage(event: any) {
      const scrollHeight = event.target.scrollHeight - 10
      const scrollTop = event.target.scrollTop + event.target.offsetHeight
      if (scrollHeight <= scrollTop && !isFetchingNextPage && hasNextPage) {
        fetchNextPage()
      }
    }

    const newProps = {
      data,
      type,
      dateSelected,
      isLoading,
      isFetchingNextPage,
      userId: user.id,
      handleFetchNextPage,
    }
    return <Component {...newProps} />
  }
  return WithSaleBookDetail
}

export default withSaleBookDetail
